module.exports = __webpack_public_path__ + "static/media/icon_specs-power.43c27827.svg";